import { loadModules } from 'esri-loader';


function featureLayerApplyEdits(attrs){
    return loadModules(["esri/layers/FeatureLayer","esri/geometry/SpatialReference","esri/Graphic"]).then(([FeatureLayer,SpatialReference,Graphic]) => {
      const waterNetworkFeatureLayer = new FeatureLayer({
        url: process.env.__MAP_SERVER_URLS__.WATER_NETWORK_FS,
        layerId: 3
      });
  
      var j = {
        "attributes":attrs
      }
  
      return waterNetworkFeatureLayer.load().then(function(f){
        console.log(f)
          return f.applyEdits({
            updateFeatures:[j]
          })  
      }).otherwise(function (err) {
        console.log("there was an error: ", err);
        return err;
      });
    });
  
}

const state = {
    OBJECTID:null,
    REMARK: null,
    Enabled: null,
    SYSTEM: null,
    SUB_SYSTEM: null,
    COMPONENT: null,
    SUB_COMPONENT: null,
    BUILDING: null,
    LEVEL_: null,
    ZONE_: null,
    POSTAL: null,
    ASSET_ID: null,
    OLD_ASSET_ID: null,
    LDZ_ID: null,
    MATERIAL: null,
    NODE_TYPE: null,
    MAIN_DIA: null,
    SEC_DIA: null,
    FAC_DES: null,
    FAC_LOC: null,
    CONTRACT_REF: null,
    INSTALL_CONT: null,
    MANUFACTURER: null,
    MODEL_NO: null,
    SERIAL_NO: null,
    BRANDNAME: null,
    SUPPLIER: null,
    INSTALL_DATE: null,
    STATUS: null,
    BUILD_ID: null,
    TENANT_NAME: null,
    CONTRACT_PERSON: null,
    TEL: null,
    FAX: null,
    EMAIL: null,
    DRAWING: null,
    FAR: null,
    QUANTITY: null,
    UNIT: null,
    SPEC_REFNO: null,
    WAR_PERIOD: null,
    WAR_EXPDATE: null,
    USEFUL_LIFE: null,    
}
// getters
const getters = {

}
const actions = {
    applyEdit({ state, commit }){
        //debugger;
        return featureLayerApplyEdits(state)
        //TBD redraw graphic
    },     
    updateAttributes({ state, commit }, newAttributeObj){
        //update resurfacing feature attributes
        commit('updateAttributes',newAttributeObj)
    },
    teardown({state,commit}){
        commit('teardown',
            {
                REMARK: null,
                Enabled: null,
                SYSTEM: null,
                SUB_SYSTEM: null,
                COMPONENT: null,
                SUB_COMPONENT: null,
                BUILDING: null,
                LEVEL_: null,
                ZONE_: null,
                POSTAL: null,
                ASSET_ID: null,
                OLD_ASSET_ID: null,
                LDZ_ID: null,
                MATERIAL: null,
                NODE_TYPE: null,
                MAIN_DIA: null,
                SEC_DIA: null,
                FAC_DES: null,
                FAC_LOC: null,
                CONTRACT_REF: null,
                INSTALL_CONT: null,
                MANUFACTURER: null,
                MODEL_NO: null,
                SERIAL_NO: null,
                BRANDNAME: null,
                SUPPLIER: null,
                INSTALL_DATE: null,
                STATUS: null,
                BUILD_ID: null,
                TENANT_NAME: null,
                CONTRACT_PERSON: null,
                TEL: null,
                FAX: null,
                EMAIL: null,
                DRAWING: null,
                FAR: null,
                QUANTITY: null,
                UNIT: null,
                SPEC_REFNO: null,
                WAR_PERIOD: null,
                WAR_EXPDATE: null,
                USEFUL_LIFE: null, 
            }    
        )
    }
}
const mutations = {
    updateAttributes(state, newAttributeObj){
        Object.assign(state, newAttributeObj)  
    },
    teardown(state, newState){
      Object.assign(state, newState)
    }    
}
export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/waterNetworkGateValve.js